const KeyRenderer = "_renderer";

export function SetRenderer(renderer) {
	window.localStorage.setItem(KeyRenderer, renderer);
}

export function GetRenderer() {
	return window.localStorage.getItem(KeyRenderer) || "webgl";
}
